/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CopyAction from './CopyAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/CollectionLabel/Content/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let collectionLabelCollectionLabelTemplateAgencyNameValueData = fromData.useDataValue({ viewPath,
context: 'collection_label',
path: 'collection_label_template.agency.name',
})
let collectionLabelCollectionLabelTemplateAgencyNameValueData1 = fromData.useDataValue({ viewPath,
context: 'collection_label',
path: 'collection_label_template.agency.name',
})
let collectionLabelCollectionLabelTemplateAgencyPhoneNumerValueData = fromData.useDataValue({ viewPath,
context: 'collection_label',
path: 'collection_label_template.agency.phone_numer',
})
let collectionLabelCollectionLabelTemplateAgencyPhoneNumerValueData1 = fromData.useDataValue({ viewPath,
context: 'collection_label',
path: 'collection_label_template.agency.phone_numer',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-10-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={75}
 weight="medium"
 color={dtColorsNeutral500}
 text="Agency ID"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 overflowX="hidden"
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 data="collection_label.collection_label_template.agency.name"
 text={collectionLabelCollectionLabelTemplateAgencyNameValueData}
/>
<CopyAction
  viewPath={`${viewPath}/CopyAction`}
 data="collection_label.collection_label_template.agency.name"
 value={collectionLabelCollectionLabelTemplateAgencyNameValueData1}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={75}
 weight="medium"
 color={dtColorsNeutral500}
 text="Agency No."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 overflowX="hidden"
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 data="collection_label.collection_label_template.agency.phone_numer"
 text={collectionLabelCollectionLabelTemplateAgencyPhoneNumerValueData}
/>
<CopyAction
  viewPath={`${viewPath}/CopyAction`}
 data="collection_label.collection_label_template.agency.phone_numer"
 value={collectionLabelCollectionLabelTemplateAgencyPhoneNumerValueData1}
/>
</div>
</div>
{children}
</React.Fragment>)
}